<div class="flex flex-column-s flex-middle">
    <!-- picture -->
    <div class="w-6 w-12-s p-r-8 p-r-0-s">
        <a [routerLink]="model.data.url">
            <img class="w-12"
                 [dfImage]="model.data.image"
                 ratio="3-2">
        </a>
    </div>
    <!-- content -->
    <div class="w-6 w-12-s p-l-8 p-l-0-s p-r-8 p-r-0-s p-t-4-s center-s">
        <!-- title -->
        <a [routerLink]="model.data.url">
            <h3 class="h3">{{model.data.name}}</h3>
        </a>

        <!-- read more -->
        @if (model.data.url) {
        <div class="m-t-6 font-1 fs-6 fs-4-s">
            <a [routerLink]="model.data.url">{{'read more' | translate}}</a>
        </div>
        }
    </div>
</div>